import { useApiListTeamsV2 } from '@repo/api-codegen/v2';
import type { SelectablePropertyItem } from '@repo/common/components/SingleSelector/types';
import { map, noop } from 'lodash-es';
import { useCallback, useMemo } from 'react';
import { useAuthUser } from '../../../api/hooks/authUser';
import { PropertySelector } from '../../Properties/PropertySelector';

export interface TeamsPropertySelectorProps {
	selected: string[];
	handleChange: (value: string[]) => void;
	allowEmpty?: boolean;
}

export function TeamsTemplateSelector({
	selected,
	handleChange,
	allowEmpty = false,
}: TeamsPropertySelectorProps) {
	const { isGuestUser } = useAuthUser();

	const { data: teams } = useApiListTeamsV2({
		queryParams: {
			only_joined: isGuestUser,
		},
	});

	const teamOptions = useMemo(
		() =>
			map(teams, (team) => ({
				label: team.name,
				value: team.id,
				icon: team.icon,
				navigateTo: '/teams',
				onClick: noop,
			})),
		[teams]
	);

	const validateSelection = useCallback(
		(
			item: SelectablePropertyItem,
			currentSelection: SelectablePropertyItem[]
		) => {
			const isCurrentlySelected = currentSelection.some(
				(s) => s.value === item.value
			);
			if (isCurrentlySelected && currentSelection.length === 1 && !allowEmpty) {
				// prevent removing the last team
				return false;
			}
			return true;
		},
		[]
	);

	return (
		<PropertySelector
			selected={selected}
			type="multi"
			value="teams"
			iconType="emoji"
			options={teamOptions}
			isViewerUser={false}
			readOnly={false}
			onChange={(value) => handleChange(value as string[])}
			returnInheritedValuesOnEmpty={false}
			placeholder={'Add team'}
			placeholderIconName="users"
			onValidateSelection={validateSelection}
		/>
	);
}
